<div class="container" *ngIf="this.type == 'withERP'">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Kunde anlegen </mat-card-title>
                    <mat-card-subtitle>Einen neuen Kunden aus einem ERP Import erstellen</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <div class="row">
                        <div class="col-sm-12 padding" *ngIf="!finishedLoadingUsers">
                            <div class="loadingOverlay">
                                <mat-spinner></mat-spinner>
                            </div>
                        </div>
                        <div class="col-sm-12" *ngIf="finishedLoadingUsers">
                            <h4>Schritt 1: Kunde auswählen</h4>
                            <div class="row" [formGroup]="serachFrom">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Suchen...</mat-label>
                                        <input matInput formControlName="searchTerm" (change)="filterUsers()">
                                        <mat-hint *ngIf="clientID == 113">
                                        <b>Suche im ERP-System nur mit Kundennummer möglich</b></mat-hint>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-12" style="margin-top: 15px;">
                                    <button mat-button mat-raised-button color="accent" (click)="filterUsers()">
                                        {{clientID == 113 ? 'Im ERP suchen' : 'Suchen'}}
                                    </button> 
                                </div>
                            </div>
       
                            <div class="example-container" *ngIf="this.dataSource?.data?.length > 0">
                                <table mat-table [dataSource]="dataSource" matSort>
                                    <ng-container matColumnDef="menu">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Auswählen
                                        </th>
                                        <td mat-cell *matCellDef="let element;let i = index;">
                                            <mat-checkbox [checked]="selected === i" (change)="selected = i"
                                                (click)="setActiveCustomer(element)">
                                            </mat-checkbox>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="user">
                                        <th mat-header-cell *matHeaderCellDef>
                                            Kunde
                                        </th>
                                        <td mat-cell *matCellDef="let element" class="mat-column w70"
                                            style="padding-right: 25px;">
                                            <span *ngIf="element?.customer?.person != null">
                                                {{element.customer.person?.displayName}} ({{element.customerKey}},
                                                {{element.customer.person.birthday | date: 'dd.MM.yyyy'}})
                                            </span>
                                            <span *ngIf="element?.customer?.person == null">
                                                Erp Sync-{{element.customerKey}} ({{element.customerKey}})
                                            </span>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                                    </tr>
                                </table>
                            </div>
                            <mat-paginator [length]="page.totalElements" class="paginator-centered"
                                [pageSize]="page.size" [pageIndex]="page.number" (page)="loadPage($event)"
                                [pageSizeOptions]="[4,8, 16, 24]" *ngIf="page">
                            </mat-paginator>
                        </div>
                    </div>

                    <h4 class="secondStep" *ngIf="selectedBusinessuser">Schritt 2: Kundendaten hinterlegen</h4>
                    <mat-stepper *ngIf="selectedBusinessuser" [orientation]="(stepperOrientation | async)!"
                        [linear]="true" [formGroup]="accountForm" #stepper>

                        <mat-step [stepControl]="accountForm" label="Kontakt">
                            <div class="row" [formGroup]="accountForm">
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Nutzername</mat-label>
                                        <input matInput type="text" formControlName="username">
                                        <mat-error *ngIf="accountForm.get('username').hasError('required')">
                                            Nutzername <strong>muss</strong> angegeben werden
                                        </mat-error>
                                        <mat-hint>
                                            Nutzername sollte E-Mail sein
                                        </mat-hint>
                                        <!-- <mat-error *ngIf="accountForm.get('username').hasError('email')">
                                            E-Mail <strong>muss</strong> ein gültiges Format haben
                                        </mat-error> -->
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Kundennummer:</mat-label>
                                        <input matInput type="text" formControlName="customerNumber">

                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Anrede:</mat-label>
                                        <mat-select formControlName="gender">
                                            <mat-option *ngFor="let sortOption of genderOptions"
                                                [value]="sortOption.value">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="accountForm.get('gender').hasError('required')">
                                            Anrede <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Titel:</mat-label>
                                        <input matInput type="text" formControlName="title">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Vorname:</mat-label>
                                        <input matInput type="text" formControlName="firstName">
                                        <mat-error *ngIf="accountForm.get('firstName').hasError('required')">
                                            Vorname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Nachname:</mat-label>
                                        <input matInput type="text" formControlName="lastName">
                                        <mat-error *ngIf="accountForm.get('lastName').hasError('required')">
                                            Nachname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Geburtstag:</mat-label>
                                        <input matInput type="date" formControlName="birthday">
                                        <mat-error *ngIf="accountForm.get('birthday').hasError('required')">
                                            Geburtstag <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Telefonnummer:</mat-label>
                                        <input matInput type="number" formControlName="phone">
                                        <mat-error *ngIf="accountForm.get('phone').hasError('required')">
                                            Telefonnummer <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>



                            <div>
                                <button mat-raised-button color="primary" matStepperNext>Weiter</button>
                            </div>

                        </mat-step>
                        <mat-step [stepControl]="addressForm" label="Addresse">
                            <div class="row" [formGroup]="addressForm">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Straße:</mat-label>
                                        <input matInput type="text" formControlName="street">
                                        <mat-error *ngIf="addressForm.get('street').hasError('required')">
                                            Straße <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>PLZ:</mat-label>
                                        <input matInput type="text" formControlName="postcode">
                                        <mat-error *ngIf="addressForm.get('postcode').hasError('required')">
                                            PLZ <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ort:</mat-label>
                                        <input matInput type="text" formControlName="city">
                                        <mat-error *ngIf="addressForm.get('city').hasError('required')">
                                            Ort <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="primary" matStepperNext
                                    style="margin-left: 15px;">Weiter</button>
                            </div>

                        </mat-step>
                        <mat-step [formGroup]="addForm">
                            <ng-template matStepLabel>Übersicht</ng-template>


                            <p style="margin: 0;"><b>Nutzername: </b> {{this.accountForm.value.username}}</p>
                            <p style="margin: 0;"><b>Kundenummer: </b> {{this.accountForm.getRawValue().customerNumber}}
                            </p>
                            <br>

                            <p style="margin: 0;"><b>Name: </b> {{this.accountForm.value?.title}}
                                {{this.accountForm.value.firstName}} {{this.accountForm.value.lastName}}</p>
                            <p style="margin: 0;"><b>Geburtstag: </b> {{this.accountForm.value.birthday | date :
                                'dd.MM.yyyy'}}</p>
                            <p style="margin: 0;"><b>Telefon: </b> {{this.accountForm.value.phone}}</p>
                            <br>

                            <p style="margin: 0;"><b>Straße: </b> {{this.addressForm.value.street}}</p>
                            <p style="margin: 0;"><b>Stadt: </b> {{this.addressForm.value.postcode}}
                                {{this.addressForm.value.city}}</p>
                            <br>

                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-checkbox formControlName="autoActivation">
                                        Kunde direkt freischalten
                                    </mat-checkbox>
                                </div>
                            </div>
                            <br>

                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="accent" matStepperNext style="margin-left: 15px;"
                                    (click)="createUser()">Kunde Anlegen</button>
                            </div>
                        </mat-step>

                    </mat-stepper>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>


<div class="container" *ngIf="this.type == 'noERP'">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Kunde anlegen </mat-card-title>
                    <mat-card-subtitle>Einen neuen Kunden ohne einen ERP Import erstellen</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <mat-stepper [orientation]="(stepperOrientation | async)!" [linear]="true" [formGroup]="accountForm"
                        #stepper>
                        <mat-step [stepControl]="accountForm" label="Kontakt">
                            <div class="row" [formGroup]="accountForm">
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Nutzername</mat-label>
                                        <input matInput type="text" formControlName="username">
                                        <mat-error *ngIf="accountForm.get('username').hasError('required')">
                                            Nutzername <strong>muss</strong> angegeben werden
                                        </mat-error>
                                        <mat-hint>
                                            Nutzername sollte E-Mail sein
                                        </mat-hint>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Kundenummer:</mat-label>
                                        <input matInput type="text" formControlName="customerNumber">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Anrede:</mat-label>
                                        <mat-select formControlName="gender">
                                            <mat-option *ngFor="let sortOption of genderOptions"
                                                [value]="sortOption.value">
                                                {{sortOption.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="accountForm.get('gender').hasError('required')">
                                            Anrede <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Titel:</mat-label>
                                        <input matInput type="text" formControlName="title">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Vorname:</mat-label>
                                        <input matInput type="text" formControlName="firstName">
                                        <mat-error *ngIf="accountForm.get('firstName').hasError('required')">
                                            Vorname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Nachname:</mat-label>
                                        <input matInput type="text" formControlName="lastName">
                                        <mat-error *ngIf="accountForm.get('lastName').hasError('required')">
                                            Nachname <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Geburtstag:</mat-label>
                                        <input matInput type="date" formControlName="birthday">
                                        <mat-error *ngIf="accountForm.get('birthday').hasError('required')">
                                            Geburtstag <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Telefonnummer:</mat-label>
                                        <input matInput type="number" formControlName="phone">
                                        <mat-error *ngIf="accountForm.get('phone').hasError('required')">
                                            Telefonnummer <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>



                            <div>
                                <button mat-raised-button color="primary" matStepperNext>Weiter</button>
                            </div>

                        </mat-step>
                        <mat-step [stepControl]="addressForm" label="Addresse">
                            <div class="row" [formGroup]="addressForm">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Straße:</mat-label>
                                        <input matInput type="text" formControlName="street">
                                        <mat-error *ngIf="addressForm.get('street').hasError('required')">
                                            Straße <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>PLZ:</mat-label>
                                        <input matInput type="text" formControlName="postcode">
                                        <mat-error *ngIf="addressForm.get('postcode').hasError('required')">
                                            PLZ <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-6">
                                    <mat-form-field class="full-width">
                                        <mat-label>Ort:</mat-label>
                                        <input matInput type="text" formControlName="city">
                                        <mat-error *ngIf="addressForm.get('city').hasError('required')">
                                            Ort <strong>muss</strong> angegeben werden
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="primary" matStepperNext
                                    style="margin-left: 15px;">Weiter</button>
                            </div>

                        </mat-step>
                        <mat-step [formGroup]="addForm">
                            <ng-template matStepLabel>Übersicht</ng-template>


                            <p style="margin: 0;"><b>Nutzername: </b> {{this.accountForm.value.username}}</p>
                            <p style="margin: 0;"><b>Kundenummer: </b> {{this.accountForm.getRawValue().customerNumber}}
                            </p>
                            <br>

                            <p style="margin: 0;"><b>Name: </b> {{this.accountForm.value?.title}}
                                {{this.accountForm.value.firstName}} {{this.accountForm.value.lastName}}</p>
                            <p style="margin: 0;"><b>Geburtstag: </b> {{this.accountForm.value.birthday | date :
                                'dd.MM.yyyy'}}</p>
                            <p style="margin: 0;"><b>Telefon: </b> {{this.accountForm.value.phone}}</p>
                            <br>

                            <p style="margin: 0;"><b>Straße: </b> {{this.addressForm.value.street}}</p>
                            <p style="margin: 0;"><b>Stadt: </b> {{this.addressForm.value.postcode}}
                                {{this.addressForm.value.city}}</p>
                            <br>

                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-checkbox formControlName="autoActivation">
                                        Kunde direkt freischalten
                                    </mat-checkbox>
                                </div>
                            </div>
                            <br>

                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="accent" matStepperNext style="margin-left: 15px;"
                                    (click)="createUser()">Kunde Anlegen</button>
                            </div>
                        </mat-step>

                    </mat-stepper>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>